// BMW (11) and MINI (85): Star Approved / Tier 1 Approved Brands / Non-Approved tire filter (TW-1134).
const approvedBrandFilterNationalAccountIds = new Set(["11", "85"]);

export const showsApprovedBrandFilter = (
  dealerNationalAccountId: string
): boolean => approvedBrandFilterNationalAccountIds.has(dealerNationalAccountId);
